import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=72f287e1&scoped=true&"
import script from "./MenuItem.vue?vue&type=script&lang=js&"
export * from "./MenuItem.vue?vue&type=script&lang=js&"
import style0 from "./MenuItem.vue?vue&type=style&index=0&id=72f287e1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f287e1",
  null
  
)

export default component.exports